import React, { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'

type HoverBoxProps = {
  trigger: React.ReactNode
  content: React.ReactNode
  className?: string
}

const HoverBox = ({ trigger, content, className = '' }: HoverBoxProps) => {
  const [hovering, setHovering] = useState(false)
  const triggerRef = useRef<HTMLDivElement | null>(null)
  const [coords, setCoords] = useState({ top: 0, left: 0 })

  useEffect(() => {
    if (hovering && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect()
      setCoords({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX - 30,
      })
    }
  }, [hovering])

  return (
    <>
      <div
        ref={triggerRef}
        className={`inline-block ${className}`}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
      >
        {trigger}
      </div>
      {hovering &&
        createPortal(
          <div
            className="absolute z-50 p-2 bg-white border fade-in border-[#B8C4E0] max-w-36 shadow-lg whitespace-normal text-sm rounded-md min-w-40 mt-1"
            style={{ position: 'absolute', top: coords.top, left: coords.left }}
          >
            {content}
          </div>,
          document.body,
        )}
    </>
  )
}

export default HoverBox
